import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Grid,
  Typography,
  MenuItem,
  TextField,
  Button,
  IconButton,
  Icon,
  CircularProgress
} from '@material-ui/core';
import {
  addTasksToQueueApi
} from 'api';


const SubscriptionAttributeSelect = ({
  label,
  attributeCode,
  savedValue,
  selectOptionsData,
  isLoading
}) => {
  const dispatch = useDispatch();

  const [attributeValue, setAttributeValue] = useState('');

  const [isEditing, setEditing] = useState(false);

  const {
    editableQuoteProduct
  } = useSelector((state: IReduxState) => state.quote);
  const {
    profile: { stores }
  } = useSelector((state: IReduxState) => state.user);
  const [{quoteProStoreCode}] = stores;

  useEffect(() => {
    if (savedValue) {
      setAttributeValue(savedValue);
    }
  }, [savedValue]);

  const attributeCodeByValue = attributeCode === 'rebill_date' ?
    selectOptionsData.find((o) => o.value == attributeValue)?.label || ''
    :
    selectOptionsData
      .find((group) => group.id == attributeValue)?.code || '';

  const handleCancel = () => {
    setAttributeValue(savedValue);
    setEditing(false);
  };

  const handleSaveProductAttributes = () => {
    const productToUpdate = {
      sku: editableQuoteProduct.sku,
      id: editableQuoteProduct.id,
      custom_attributes: [
        {
          attribute_code: attributeCode,
          value: attributeValue
        }
      ]
    };
    const task = {
      body: productToUpdate,
      name: editableQuoteProduct.name,
      sku: editableQuoteProduct.sku,
      requestType: 'UPDATE_PRODUCT',
      storeViewCode: quoteProStoreCode
    };
    addTasksToQueueApi({dispatch, tasks: [task]});
    setEditing(false);
  };

  return (
    <>
      <Grid item xs={3}>{label}</Grid>
      <Grid item xs={9}>
        {isLoading
          ? <CircularProgress className="ml-2" />
          :
          <Typography variant="body1" className={isEditing ? null : 'pt-0'}>
            {isEditing ?
              <div className="flex items-center">
                <TextField
                  select
                  variant="outlined"
                  name="name"
                  className="w-full max-w-300"
                  value={attributeValue}
                  onChange={({target: {value}}) => setAttributeValue(value)}
                >
                  {selectOptionsData.map((attr) => (
                    <MenuItem
                      key={attributeCode === 'rebill_date' ? attr.value  : attr.id}
                      value={attributeCode === 'rebill_date' ? attr.value  : attr.id}
                    >
                      {attributeCode === 'rebill_date' ? attr.label : attr.code}
                    </MenuItem>
                  ))}
                </TextField>
                <Button
                  variant="contained"
                  className="ml-2"
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  className="ml-2"
                  onClick={handleSaveProductAttributes}
                >
                  Save
                </Button>
              </div>
              :
              <div className="flex items-center">
                {attributeCodeByValue}
                <IconButton
                  title="Edit Product Title"
                  className="ml-2"
                  onClick={() => setEditing(true)}
                >
                  <Icon>edit</Icon>
                </IconButton>
              </div>
            }
          </Typography>
        }
      </Grid>
    </>
  );
};

export default SubscriptionAttributeSelect;
